import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const isProd = false;

const COLORS = {
  primary: '#6366f1', 
  secondary: '#8b5cf6', 
  success: '#10b981', 
  warning: '#f59e0b', 
  error: '#ef4444', 
  dark: '#1e293b',
  light: '#f8fafc',
  accent: '#fcd20e',
};

const badge = (bg: string, color: string) =>
  `background:${bg};color:${color};padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600;letter-spacing:0.05em;text-transform:uppercase;`;

const STYLES = {
  version: badge(COLORS.secondary, '#fff'),
  log: 'color:#64748b;font-size:12px;',
  info: `color:${COLORS.accent};font-size:12px;font-weight:500;`,
  success: `color:${COLORS.success};font-size:12px;font-weight:500;`,
  warn: badge('#fef3c7', '#92400e'),
  brand:
    'background:#6366f1;color:#fff;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600;',
  error:
    'background:#fee2e2;color:#991b1b;padding:3px 10px;border-radius:6px;font-size:11px;font-weight:600;',
  debug: 'color:#94a3b8;font-size:12px;font-style:italic;',
  timestamp: 'color:#cbd5e1;font-size:10px;',
};

const SUPPRESS = [
  'modified by ngx-extended-pdf-viewer',
  'PDF.js',
  'Angular is running',
  'Unable to preventDefault inside passive event listener invocation',
  'Autofocus processing was blocked because a document already has a focused element',
];

const shouldSuppress = (args: any[]) =>
  SUPPRESS.some((s) => typeof args[0] === 'string' && args[0].includes(s));

const original = {
  log: console.log.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  debug: console.debug.bind(console),
};

const time = () =>
  new Date().toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

const prefix = (style: string) => ['%cMNE%c ' + time(), STYLES.brand, style];

console.log = (...args) => {
  if (shouldSuppress(args)) return;
  original.log(...prefix(STYLES.log), ...args);
};

console.info = (...args) => {
  if (shouldSuppress(args)) return;
  original.info(...prefix(STYLES.info), 'ℹ', ...args);
};

console.warn = (...args) => {
  if (shouldSuppress(args)) return;
  const msg = typeof args[0] === 'string' ? args[0] : 'Warning';
  original.warn(...prefix(STYLES.warn), '%c ' + msg, STYLES.warn, ...args.slice(1));
};

console.error = (...args) => {
  if (shouldSuppress(args)) return;

  const msg = args[0] instanceof Error ? args[0].message : String(args[0]);

  original.error('%cMNE%c %cERROR%c', STYLES.brand, '', STYLES.error, '', msg, ...args.slice(1));
};

console.debug = (...args) => {
  if (isProd) return;
  if (shouldSuppress(args)) return;
  original.debug(...prefix(STYLES.debug), '◆', ...args);
};

console.info('Application starting...');

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
